export default {
  title: 'Laatste 4 weken',
  item_interval: '(1)[1 keer bezocht];(2)[2 keer bezocht];(3-5)[3-5 keer bezocht];(6-inf)[6+ keer bezocht];',
  total: 'Totaal bezoekers',
};
